import axios from 'axios';

const API_BASE = '/api/vendor-invoices';

export const vendorInvoiceService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  getNextNumber: async () => {
    const response = await axios.get(`${API_BASE}/next-number`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
